<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>workplace</md-icon>
                    </div>
                    <h4 class="title">Update Workplace</h4>
                </md-card-header>

                <form @submit.prevent="update">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>

                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="workplace.name" />
                                    <validation-error :errors="apiValidationErrors.name" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Item Number
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="workplace.item_number" />
                                    <validation-error :errors="apiValidationErrors.item_number" />
                                </md-field>
                            </div>
                        </div>


                        <select-input-horizontal
                                v-model="workplace.port.id"
                                :options="available_ports_dropdown"
                                placeholder="Select Port"
                                label="Port"
                                name="name"
                                track-by="id"
                                main-class="md-layout"
                                label-class="md-layout-item md-size-25 md-form-label"
                                :error="apiValidationErrors.port_id"
                        ></select-input-horizontal>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Description
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="workplace.location" />
                                    <validation-error :errors="apiValidationErrors.location" />
                                </md-field>
                            </div>
                        </div>
                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success"
                        >Update Workplace</md-button
                        >
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>

<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';

import SelectInputHorizontal from '../../../components/Inputs/SelectInputHorizontal';
import Vuex from 'vuex';

export default {
    components: { ValidationError,SelectInputHorizontal },

    mixins: [formMixin],

    data: () => ({
        workplace: {
            type: 'workplaces',
            name: null,
            location: null,
            port_id:null
        },
        available_ports_dropdown: []

    }),

    created () {
        this.get();
        this.getPortDropDowns();
    },

    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('workplaces/get', id);
                this.workplace = this.$store.getters['workplaces/workplace'];
                this.workplace.port_id = this.workplace.port.id;
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },

        async update () {
            try {
                delete this.workplace.created_at;
                await this.$store.dispatch('workplaces/update', this.workplace);
                await this.$store.dispatch(
                    'alerts/success',
                    'Workplace updated successfully.'
                );
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].title
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },

        goBack () {
            this.$router.push({ name: 'Workplaces List' });
        },
        getPortDropDowns () {
            let portParams = { filter: { 'station': '' } };
            let station = this.user_department ? this.user_department.station : null;
            if (typeof station !== 'undefined' && station != null) {
                portParams.filter.station = station.id;
            } else {
                portParams = null;
            }
            this.$store.dispatch('ports/list', portParams).then(() => {
                this.available_ports_dropdown = this.$store.getters['ports/dropdown'];
                if (this.available_ports_dropdown && this.available_ports_dropdown.length) {
                    // todo set user port as default
                    // check for station in user department
                    if (typeof this.user_department.port !== 'undefined') {
                        this.guidance.port_id = this.user_department.port.id;
                    }
                    // this.guidance.options = this.available_ports_dropdown[0].id;
                }
            });
        },
    },
    computed: {
        ...Vuex.mapState({
            me: state => state.profile.me
        }),
    },
    watch: {
        me: {
            handler: function (val) {
                if (val != null) {
                    this.user_department = val.model.department;
                    this.getPortDropDowns();
                } else {
                    this.notifyError('Your Department is not found');
                }
            },
            deep: true,
            immediate: true,
        },
    }
};
</script>

<style lang="scss">
    .spacing {
        padding-bottom: 1rem;
    }
</style>
